import React from "react";
import { SvgProps } from "../types";

const Icon: React.FC<React.PropsWithChildren<SvgProps>> = (props) => {
  return (
    <svg width={23} height={29} viewBox="0 0 23 29" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="11.4906" cy="12.0217" r="2.02773" fill="#F59C53" />
      <circle cx="11.2652" cy="11.7964" r="10.364" stroke="white" strokeWidth="1.80243" />
      <circle cx="11.4906" cy="17.429" r="2.02773" fill="#F59C53" />
      <circle cx="11.2652" cy="17.2036" r="10.364" stroke="white" strokeWidth="1.80243" />
    </svg>
  );
};

export default Icon;
